import React, { useState } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import FableticsModal from '~/shared/components/FableticsModal';
import { Button } from '~/techstyle-shared/react-components';

const IconButton = styled(Button)`
  padding: 0px;
  border: none;
  background: none;

  span {
    color: black;
  }

  &:focus,
  &:hover {
    opacity: unset;
    background: none;
  }
`;

const ModalContentWrapper = styled.div`
  max-width: 600px;
`;

const HeaderWrapper = styled.h2`
  margin-bottom: 16px;

  ${({ theme }) => theme.iconButtonModal.header}
`;

const BodySubheader = styled.h3`
  margin-bottom: 4px;

  ${({ theme }) => theme.iconButtonModal.subheader}
`;

const BodyCopy = styled.p`
  ${({ theme }) => theme.iconButtonModal.copy}
`;

const BodyWrapper = styled.div`
  > ${BodyCopy}:not(:last-child) {
    margin-bottom: 24px;
  }
`;

/**
 * @function IconButtonModal
 * @description Component that renders an icon button and when clicked will present the user
 * with a modal consisting of a header, body copy, and a 'x' close button.
 *
 * @param {Object} props - The props for the button.
 * @param {Function} props.headerContent - The header copy to display in the modal
 * @param {Function} props.bodyContent - The body copy to display in the modal
 * @param {Function} props.icon - The icon to display as a button to the user, which when clicked
 * triggers the modal
 *
 * @returns {JSX.Element}
 */
function IconButtonModal({
  headerContent: HeaderContent,
  bodyContent: BodyContent,
  icon: Icon,
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <IconButton onClick={() => setShowModal(true)}>
        <Icon />
      </IconButton>

      <FableticsModal
        title="icon_button_modal"
        isOpen={showModal}
        showCloseButton
        onExit={() => setShowModal(false)}
      >
        <ModalContentWrapper>
          <HeaderWrapper>
            <HeaderContent />
          </HeaderWrapper>

          <BodyWrapper>
            <BodyContent />
          </BodyWrapper>
        </ModalContentWrapper>
      </FableticsModal>
    </>
  );
}

IconButtonModal.propTypes = {
  bodyContent: PropTypes.func,
  headerContent: PropTypes.func,
  icon: PropTypes.func,
};

IconButtonModal.BodySubheader = BodySubheader;
IconButtonModal.BodyCopy = BodyCopy;

export default IconButtonModal;
